import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import styles from '../styles/PageWrapper.scss';
import iconSparkle from '../assets/IconSparkle.svg';

export const ChatLanding = ({ sendMessage }) => {
  const intl = useIntl();

  const exampleInputs = [
    intl.formatMessage({ id: 'userInput.example1' }),
    intl.formatMessage({ id: 'userInput.example2' }),
    intl.formatMessage({ id: 'userInput.example3' }),
  ];

  return (
    <>
      <div className={`${styles.titleMarginTop} flex flex-column flex-item-grow`}>
        <div className={styles.chatIntroHeaderWrapper}>
          <div
            className="heading-serif-large-regular flex flex-column"
            style={{ fontSize: '34px !important', fontWeight: '300' }}
          >
            {intl.formatMessage({ id: 'chatIntroTitle1' })}
            {intl.formatMessage({ id: 'chatIntroTitle2' })}
          </div>
          <div className={`${styles.subTitleContainer} flex flex-column body-3 pad-2-t`}>
            {intl.formatMessage({ id: 'chatIntroSubtitle1' })}
            {intl.formatMessage({ id: 'chatIntroSubtitle2' })}
          </div>
        </div>
      </div>
      <div
        className={`${styles.scrollbarHide} ${styles.reverseMargin} flex pad-1-b scroll-x`}
      >
        {exampleInputs.map((input) => (
          <button
            key={input}
            type="button"
            aria-label={`Example input for AI suggestions - ${input}`}
            onClick={() => sendMessage(input)}
            className={
                `${styles.hoverUnderline} 
                ${styles.borderRadiusText}
                ${styles.buttonBox}
                margin-1-b pad-2-lr pad-2-t pad-3-b`
              }
          >
            <div className="flex flex-align-center">
              <img
                src={iconSparkle}
                alt="Decorative icon for AI suggestions"
              />
            </div>
            <div
              className={`text-align-left body-3 ${styles.exampleInputText}`}
            >
              {input}
            </div>
          </button>
        )
        )}
      </div>
    </>
  );
};

ChatLanding.propTypes = {
  sendMessage: PropTypes.func.isRequired,
};
